import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgTokenSolid = function SvgTokenSolid(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        d: "M17.5 6.422a1 1 0 0 0-.514-.874l-6.5-3.612a1 1 0 0 0-.972 0l-6.5 3.612a1 1 0 0 0-.514.874v7.156a1 1 0 0 0 .514.874l6.5 3.612a1 1 0 0 0 .972 0l6.5-3.612a1 1 0 0 0 .514-.874zM9.757 3.71a.5.5 0 0 1 .486 0l4.367 2.423a.2.2 0 0 1 0 .35L12.417 7.7a3.346 3.346 0 0 0-4.833 0L5.39 6.483a.2.2 0 0 1 0-.35zm-.59 11.917a.2.2 0 0 1-.297.175l-4.446-2.467a.5.5 0 0 1-.257-.438v-4.84a.2.2 0 0 1 .297-.175l2.311 1.285a3.326 3.326 0 0 0 2.392 4.058zM8.333 10c0-.917.75-1.667 1.667-1.667s1.667.75 1.667 1.667-.75 1.667-1.667 1.667-1.667-.75-1.667-1.667m2.797 5.802a.2.2 0 0 1-.297-.175v-2.394a3.326 3.326 0 0 0 2.5-3.225c0-.291-.033-.575-.108-.841l2.311-1.285a.2.2 0 0 1 .297.175v4.84a.5.5 0 0 1-.257.438z"
    })));
};

export { SvgTokenSolid as ReactComponent };
//# sourceMappingURL=TokenSolid.svg.es.js.map
